export default "__VITE_ASSET__1f5869fa__"